import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { mappedLocales } from '@core/Utils/Intl/MappedLocales';

import { Button } from '@gds/Button/Button';
import { Input } from '@gds/Input/Input';
import { Slider } from '@gds/Slider/Slider';
import { Typography } from '@gds/Typography/Typography';
import { useAtomValue } from 'jotai';

import { useRangeFilters } from 'Hooks/SearchFilters/UseRangeFilters';

import { FilterControlBaseProps } from '../../FilterPanel.entity';

import { CONSUMPTION_RANGE } from './ConsumptionFilter.constants';

import styles from './ConsumptionFilter.module.css';

type ConsumptionFilterProps = FilterControlBaseProps;

export const ConsumptionFilter = ({ strings, locale }: ConsumptionFilterProps) => {
  const minVal = CONSUMPTION_RANGE[0].toString();
  const maxVal = CONSUMPTION_RANGE[CONSUMPTION_RANGE.length - 1].toString();
  const { totalCount } = useAtomValue(aggregationsAtom);

  const { gteInputProps, lteInputProps, sliderProps, canReset, reset } = useRangeFilters(
    'fuel-consumption',
    CONSUMPTION_RANGE,
    [minVal, maxVal],
  );

  return (
    <section className={styles.consumptionFilter}>
      <div className={styles.minMaxInputs}>
        <Input
          {...gteInputProps}
          label={strings.min}
          type="number"
          min={0}
          step={1}
          onKeyDown={e => {
            if (e.key === '.' || e.key === ',') {
              e.preventDefault();
            }
          }}
          rightAddons={<span className={styles.unit}>l/100km</span>}
        />
        <Input
          {...lteInputProps}
          label={strings.max}
          type="number"
          max={maxVal}
          step={1}
          onKeyDown={e => {
            if (e.key === '.' || e.key === ',') {
              e.preventDefault();
            }
          }}
          rightAddons={<span className={styles.unit}>l/100km</span>}
        />
      </div>
      <div className={styles.auxInfo}>
        <Typography Component="span" className={styles.resultCount} variant="caption2">
          ({totalCount.toLocaleString(mappedLocales[locale])})
        </Typography>
        <Button
          color="secondary"
          disabled={!canReset()}
          onClick={() => reset()}
          size="small"
          variant="link"
        >
          {strings.reset}
        </Button>
      </div>
      <Slider
        {...sliderProps}
        className={styles.priceRangeSlider}
        dataTestId="consumption-slider"
      />
    </section>
  );
};
